export const myHausHeldLanding = {
  myHausHeldFeaturesTitle: 'Ihr ganz persönlicher myHausHeld-Zugang - Einfach Überall',
  myHausHeldFeaturesSubtitle:
    'Mit Ihrem kostenlosen Konto können Sie jederzeit auf alle Funktionen von myHausHeld zugreifen. Planen Sie Ihre Sanierungen, betrachten Sie Ihre Offerten, analysieren Sie den Zustand Ihres Gebäudes und vieles mehr.',
  renovations: 'Renovationen',
  renovationsText:
    'Mit dem Renovationsmanager behalten Sie Ihre Renovationen im Blick und haben stets Zugriff auf wichtige Informationen und Dokumente.',
  analysis: 'Gebäudeanalyse',
  analysisText:
    'Die Gebäudeanalyse zeigt Ihnen anstehende Sanierungsmassnahmen und zu erwartende Kosten.',
  appointmentsAndTodos: 'Termine und To-dos',
  appointmentsAndTodosText:
    'Mit myHausHeld erfassen Sie Ihre Termine und To-Dos zu Ihren Renovationen',
  invoices: 'Meine Rechnungen',
  invoicesText:
    'Mit myHausHeld bekommen Sie eine Übersicht aller Rechnungen und absetzbarer Kosten.',
  documents: 'Meine Unterlagen',
  documentsText:
    'Sichern und kategorisieren Sie Bilder, Rechnungen und weitere Dokumente auf Schweizer Rechenzentren.',
  financeAndMortgage: 'Finanzen und Hypotheken',
  financeAndMortgageText:
    'Dank erstklassiger Partner profitieren Sie von unschlagbaren Finanz-Angeboten. Vergleichen Sie schnell und einfach attraktive Angebote.',
  renovationsBulletPoint1: 'Digitale Verwaltung Ihrer Renovationen',
  renovationsBulletPoint2: 'Alle wichtigen Informationen an einem Ort',
  renovationsBulletPoint3: 'Viele nützliche Funktionen wie Offerten, Notizen, Termine und To-Dos',
  renovationsBulletPoint4: 'Speichern Sie Dokumente zu Ihrem Projekt',
  analysisBulletPoint1: 'Digitale Verwaltung Ihrer Immobilie',
  analysisBulletPoint2: 'Analyse zur Lebensdauer der Komponenten Ihrer Immobilie',
  analysisBulletPoint3: 'Kostenlose Schätzung der Renovationskosten mit unserem Sanierungsrechner',
  appointmentsAndTodosBulletPoint1: 'Digitale Verwaltung Ihrer To-dos',
  appointmentsAndTodosBulletPoint2: 'Digitale Terminverwaltung inklusive Erinnerungsfunktion',
  appointmentsAndTodosBulletPoint3:
    'Verknüpfen Sie Ihre Termine und To-dos mit Ihren Projekten und Ihrer Immobilie',
  invoicesBulletPoint1: 'Digitale Erfassung von Liegenschaftsrechnungen',
  invoicesBulletPoint2: 'Auflistung der von den Steuern abziehbaren Kosten',
  invoicesBulletPoint3: 'Einfach Steuern sparen',
  documentsBulletPoint1: 'Kostenlose Dokumentenablage',
  documentsBulletPoint2: 'Speichern Sie nützliche Information zu Ihren Dokumenten in Notizen',
  documentsBulletPoint3: 'Kategorien ermöglichen die strukturierte Ablage Ihrer Dokumente',
  documentsBulletPoint4: 'Ablage von Bildern, Rechnungen, Offerten, Handbüchern und Anleitungen',
  financeAndMortgageBulletPoint1: 'Vergleichen Sie Hypothekar-Angebote',
  financeAndMortgageBulletPoint2:
    'Profitieren Sie von heldenhaften Zinsen für Ihre Anschlussfinanzierung',
  financeAndMortgageBulletPoint3: 'Erhalten Sie eine kostenlose Immobilienbewertung',
  dataSecurity: 'Datenstandort Schweiz',
  dataSecurityText:
    'Die Sicherheit Ihrer Daten hat Priorität für uns, deshalb speichern wir Ihre Daten ausschliesslich in Schweizer Rechenzentren und geben Ihre Daten nicht an Dritte weiter. Unsere Infrastruktur entspricht den modernsten Sicherheitsstandards und bietet so den optimalen Schutz Ihrer Daten.',
  minergieTitle: 'Profitieren Sie vom Angebot unseres Partners Minergie',
  minergieText:
    'Mit dem Öko-Dämmrechner erfahren Sie, wie stark gedämmt werden sollte, um die Umwelt durch das Heizen des Gebäudes möglichst wenig zu belasten und Geld zu sparen.',
  swissLifeText:
    'Mit dem Angebot unseres Partners Swiss Life können Sie mit wenigen Klicks den Wert Ihrer Immobilie berechnen oder eine Expertenschätzung einholen. Nutzen Sie die Möglichkeit, um das Beste für den Verkauf Ihrer Liegenschaft rauszuholen.',
  wirText:
    'Dank unserer vertrauensvollen Partnerschaft mit der Bank WIR können wir Ihnen exklusive Angebote für Ihre Anschlussfinanzierung offerieren. Mit der HausHeld-Hypothek erhalten Sie attraktive Zinssätze und sichern sich so einfach und schnell finanziellen Spielraum für Ihre Zukunft.',
  minergieButtonText: 'Jetzt kostenlos berechnen',
}
